import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { FiCloud, FiTwitter, FiUser } from "react-icons/fi";
import { useCookies } from "react-cookie";
import axios from "axios";

import icon from "../assets/icon-rounded.png";

import "./css/header.css";

export default function HeaderBar() {

    const [cookies, setCookie, removeCookie] = useCookies(["userPuuId"]);

    var userId = cookies.userPuuId;

    useEffect(() => {
        if(userId) {
            axios.get(`https://cloudify-backend.herokuapp.com/users/get/byid/${userId}`)
            .then(resp => {
                console.log(resp.data)
                document.getElementById("userButtonImage").href = `/users/${resp.data.userInfo.userId}`;

                document.getElementById("userImage").src = resp.data.userInfo.profilePicture;

                document.getElementById("userIcon").hidden = true;
                document.getElementById("userButton").hidden = true;
                document.getElementById("userImage").hidden = false;
            });
        }
        else return false;
    }, []);

    return (
        <div className="bar" id="headerBarContainer">

            <div id="titleContainer">
                {/* <FiCloud style={{"fontSize":"24px", "color":"white"}}/> */}
                <img src={icon} style={{height:"24px", width:"24px"}} />
                <h2 id="cloudTitle" style={{"marginLeft":"4px"}}>Bookshelter</h2>
            </div>

            <div id="secondInfo">
                <FiTwitter style={{"marginRight":"10px"}} />
                <a href="http://bibliotecas.cultura.gov.br/busca/##(global:(enabled:(space:!t),filterEntity:space))"> <h3>Encontre uma livraria</h3> </a>
                <a id="userButton" href="/login" > <FiUser id="userIcon" className="userButtonDefault"  /> </a>
                <a id="userButtonImage" > <img id="userImage" className="userButtonLogged" hidden /> </a>
            </div>
        </div>
    )
}